import { Autocomplete, Button, Grid, Grow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getMyVote, postMyVote, postVoteCarol, postVoteChant, postVoteStarNight } from '../adminmenus/JudgeMenusRequests';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { blue, pink, red } from '@mui/material/colors';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { getListOfGroups } from '../adminmenus/AdminMenusRequests';
import { GroupOutlined } from '@mui/icons-material';
export const Vote = () => {
    useEffect(()=>{
        _init();
        _getGName();
    },[])
    const user = JSON.parse(localStorage.getItem('user'));
    const [isStarted,setIstarted] = useState('')
    const [votedMale,setVotedMale] = useState('');
    const [votedFemale,setVotedFemale] = useState('');
    const [votedChant,setVotedChant] = useState('');
    const [votedCarol,setVotedCarol] = useState('');
    const [votedStar,setVotedStar] = useState('');
    const [allParticipants,setAllParticipants] = useState([])
    const [maleParticipants,setMaleParticipants] = useState([])
    const [femaleParticipants,setFemaleParticipants] = useState([]);
    const [listOfGroups,setListOfGroups] = useState([]);
    const _getGName = async () => {
        const res = await getListOfGroups();
        console.log(res.data)
        setListOfGroups(res.data.data)
    }
    const _init = async () => {
        const res = await getMyVote({id:user.id})
        console.log(res.data)
        setMaleParticipants(res.data.data.male)
        setFemaleParticipants(res.data.data.female)
        setAllParticipants(res.data.data.data)
        setVotedMale(res.data.male_voted)
        setVotedFemale(res.data.female_voted)
        setIstarted(res.data.is_started)
        setVotedChant(res.data.voted_chant)
        setVotedCarol(res.data.voted_carol)
        setVotedStar(res.data.voted_star)

    }
    const [selectedMale,setSelectedMale] = useState(null);
    const [selectedFemale,setSelectedFemale] = useState(null);
    const [selectedStarNigth,setSelectedStarNigth] = useState(null);
    const [selectedChantGroup,setSelectedChantGroup] = useState(null);
    const [selectedCarolGroup,setSelectedCarolGroup] = useState(null);
    const handleVote = async (sex,selectedData) =>{
        if(selectedData){
            Swal.fire({
                icon:'question',
                title:'Confirm Vote ?',
                confirmButtonText:'Yes, I confirm',
                cancelButtonText:'No, Cancel',
                showCancelButton:true
            }).then( async res=>{
                if(res.isConfirmed){
                    const toastId = toast.loading('Submitting vote'); 
                    let t_data = {
                        user:user,
                        selected:sex === 'MALE'?selectedMale:selectedFemale
                    }
                    const res = await postMyVote(t_data)
                    if(res.data.status === 200){
                        setVotedMale(res.data.data.male_voted)
                        setVotedFemale(res.data.data.female_voted)
                        toast.success(res.data.message, {
                            id: toastId,
                        });
                    }else{
                        toast.error(res.data.message, {
                            id: toastId,
                        });
                    }
                }
            })
        }else{
            toast.error('Oops...Please a select name to vote !',{
                duration:3000
            })
        }
        
        
    }
    const handleVoteChant = async () => {
        if(selectedChantGroup){
            Swal.fire({
                icon:'question',
                title:'Confirm Vote ?',
                confirmButtonText:'Yes, I confirm',
                cancelButtonText:'No, Cancel',
                showCancelButton:true
            }).then( async res=>{
                if(res.isConfirmed){
                    const toastId = toast.loading('Submitting vote'); 
                    let t_data = {
                        user:user,
                        group:selectedChantGroup
                    }
                    const res = await postVoteChant(t_data)
                    if(res.data.status === 200){
                        setVotedChant(res.data.data.voted_chant)
                        toast.success(res.data.message, {
                            id: toastId,
                        });
                    }else{
                        toast.error(res.data.message, {
                            id: toastId,
                        });
                    }
                }
            })
        }else{
            toast.error('Oops...Please a select name to vote !',{
                duration:3000
            })
        } 
    }
    const handleVoteCarol = async () => {
        if(selectedCarolGroup){
            Swal.fire({
                icon:'question',
                title:'Confirm Vote ?',
                confirmButtonText:'Yes, I confirm',
                cancelButtonText:'No, Cancel',
                showCancelButton:true
            }).then( async res=>{
                if(res.isConfirmed){
                    const toastId = toast.loading('Submitting vote'); 
                    let t_data = {
                        user:user,
                        group:selectedCarolGroup
                    }
                    const res = await postVoteCarol(t_data)
                    if(res.data.status === 200){
                        setVotedCarol(res.data.data.voted_carol)
                        toast.success(res.data.message, {
                            id: toastId,
                        });
                    }else{
                        toast.error(res.data.message, {
                            id: toastId,
                        });
                    }
                }
            })
        }else{
            toast.error('Oops...Please a select name to vote !',{
                duration:3000
            })
        } 
    }
    const handleVoteStar = async () => {
        if(selectedStarNigth){
            Swal.fire({
                icon:'question',
                title:'Confirm Vote ?',
                confirmButtonText:'Yes, I confirm',
                cancelButtonText:'No, Cancel',
                showCancelButton:true
            }).then( async res=>{
                if(res.isConfirmed){
                    const toastId = toast.loading('Submitting vote'); 
                    let t_data = {
                        user:user,
                        star:selectedStarNigth  
                    }
                    const res = await postVoteStarNight(t_data)
                    if(res.data.status === 200){
                        setVotedStar(res.data.data.voted_star)
                        toast.success(res.data.message, {
                            id: toastId,
                        });
                    }else{
                        toast.error(res.data.message, {
                            id: toastId,
                        });
                    }
                }
            })
        }else{
            toast.error('Oops...Please a select name to vote !',{
                duration:3000
            })
        } 
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant='h5'>Best Dress Vote</Typography>
            </Grid>
            {
                isStarted === ''
                ?
                null
                :
                isStarted
                ?
                <>
                    <Grid item xs={12} sx={{display:'flex'}}>
                    {
                        votedMale === ''
                        ?
                        null
                        :
                        votedMale
                        ?
                        <Grow in>
                            <Paper sx={{width:'100%',p:2}}>
                            <Typography variant='h6' sx={{display:'flex',alignItems:'center'}}><ManIcon fontSize='large' sx={{color:blue[800]}}/> Male Category </Typography>
                            <Typography sx={{color:blue[700],pl:4}}>#{`${votedMale.number} - ${votedMale.name} (${votedMale.office})`}</Typography>
                            </Paper>
                        </Grow>
                        :
                        <Grow in>
                            <Paper sx={{width:'100%',p:2,display:'flex'}}>
                            <Autocomplete
                                disablePortal
                                id={"combo-box-male-cat"}
                                options={maleParticipants}
                                getOptionLabel={(option) => `#${option.number} - ${option.name} (${option.office})`}
                                sx={{ width: 300}}
                                // fullWidth
                                value = {selectedMale}
                                onChange={(event, newValue) => {
                                    setSelectedMale(newValue);
                                    }}
                                renderInput={(params) => <TextField {...params} label="Male Category" />}
                            />
                        <Button variant='contained' onClick={()=>handleVote('MALE',selectedMale)} startIcon={<ThumbUpIcon/>}>Vote</Button>
                        </Paper>
                        </Grow>
                    }
                </Grid>
                <Grid item xs={12} sx={{display:'flex'}}>
                    {
                        votedFemale === ''
                        ?
                        null
                        :
                        votedFemale
                        ?
                        <Grow in>
                            <Paper sx={{width:'100%',p:2}}>
                            <Typography variant='h6' sx={{display:'flex',alignItems:'center'}}><WomanIcon fontSize='large' sx={{color:pink[400]}}/> Female Category </Typography>
                            <Typography sx={{color:pink[400],pl:4}}>#{`${votedFemale.number} - ${votedFemale.name} (${votedFemale.office})`}</Typography>
                            </Paper>
                        </Grow>
                        :
                        <Grow in>
                            <Paper sx={{width:'100%',p:2,display:'flex'}}>
                            <Autocomplete
                                disablePortal
                                id={"combo-box-male-cat"}
                                options={femaleParticipants}
                                getOptionLabel={(option) => `#${option.number} - ${option.name} (${option.office})`}
                                sx={{ width: 300}}
                                // fullWidth
                                value = {selectedFemale}
                                onChange={(event, newValue) => {
                                    setSelectedFemale(newValue);
                                    }}
                                renderInput={(params) => <TextField {...params} label="Female Category" />}
                            />
                            <Button variant='contained' onClick={()=>handleVote('FEMALE',selectedFemale)} startIcon={<ThumbUpIcon/>}>Vote</Button>
                        </Paper>
                        </Grow>
                    }
                </Grid>
                </>
                :
                <Grid item xs={12}>
                    <Typography variant='h6' sx={{color:red[800],textAlign:'center'}}>Voting is not yet open</Typography>
                </Grid>
            }
            <Grid item xs={12}>
                <hr/>
                <Typography variant='h5'>Group Chant</Typography>
            </Grid>
            <>
                <Grid item xs={12} sx={{display:'flex'}}>
                {
                    votedChant === ''
                    ?
                    null
                    :
                    votedChant
                    ?
                    <Grow in>
                        <Paper sx={{width:'100%',p:2}}>
                        {/* <Typography variant='h6' sx={{display:'flex',alignItems:'center'}}><GroupOutlined fontSize='large' sx={{color:blue[800]}}/> Group </Typography> */}
                        <Typography variant='h6' sx={{color:blue[700],pl:4}}>{`${votedChant.group_name}`}</Typography>
                        </Paper>
                    </Grow>
                    :
                    <Grow in>
                        <Paper sx={{width:'100%',p:2,display:'flex'}}>
                        <Autocomplete
                            disablePortal
                            id={"combo-box-male-cat"}
                            options={listOfGroups}
                            getOptionLabel={(option) => `${option.group_name}`}
                            sx={{ width: 300}}
                            // fullWidth
                            value = {selectedChantGroup}
                            onChange={(event, newValue) => {
                                setSelectedChantGroup(newValue);
                                }}
                            renderInput={(params) => <TextField {...params} label="Group" />}
                        />
                    <Button variant='contained' onClick={handleVoteChant} startIcon={<ThumbUpIcon/>}>Vote</Button>
                    </Paper>
                    </Grow>
                }
                </Grid>
                

            </>
            <Grid item xs={12}>
                <hr/>
                <Typography variant='h5'>Christmas Carol</Typography>
            </Grid>
            <>
                <Grid item xs={12} sx={{display:'flex'}}>
                {
                    votedCarol === ''
                    ?
                    null
                    :
                    votedCarol
                    ?
                    <Grow in>
                        <Paper sx={{width:'100%',p:2}}>
                        {/* <Typography variant='h6' sx={{display:'flex',alignItems:'center'}}><ManIcon fontSize='large' sx={{color:blue[800]}}/> Group </Typography> */}
                        {/* <Typography sx={{color:blue[700],pl:4}}>{`${votedCarol.group_name}`}</Typography> */}
                        <Typography variant='h6' sx={{color:blue[700],pl:4}}>{`${votedCarol.group_name}`}</Typography>
                        </Paper>
                    </Grow>
                    :
                    <Grow in>
                        <Paper sx={{width:'100%',p:2,display:'flex'}}>
                        <Autocomplete
                            disablePortal
                            id={"combo-box-male-cat"}
                            options={listOfGroups}
                            getOptionLabel={(option) => `${option.group_name}`}
                            sx={{ width: 300}}
                            // fullWidth
                            value = {selectedCarolGroup}
                            onChange={(event, newValue) => {
                                setSelectedCarolGroup(newValue);
                                }}
                            renderInput={(params) => <TextField {...params} label="Group" />}
                        />
                    <Button variant='contained' onClick={handleVoteCarol} startIcon={<ThumbUpIcon/>}>Vote</Button>
                    </Paper>
                    </Grow>
                }
                </Grid>
            </>
            <Grid item xs={12}>
                <hr/>
                <Typography variant='h5'>Star of the Night</Typography>
            </Grid>
            <>
                <Grid item xs={12} sx={{display:'flex'}}>
                {
                    votedStar === ''
                    ?
                    null
                    :
                    votedStar
                    ?
                    <Grow in>
                        <Paper sx={{width:'100%',p:2}}>
                        <Typography variant='h6' sx={{display:'flex',alignItems:'center'}}>
                            {
                                votedStar.sex === 'MALE'
                                ?
                                <ManIcon fontSize='large' sx={{color:blue[800]}}/>
                                :
                                <WomanIcon fontSize='large' sx={{color:pink[400]}}/>

                            }
                            {votedStar.sex}
                            </Typography>
                        <Typography sx={{color:blue[700],pl:4}}>{`#${votedStar.number} - ${votedStar.participant_name} (${votedStar.office})`}</Typography>
                        </Paper>
                    </Grow>
                    :
                    <Grow in>
                        <Paper sx={{width:'100%',p:2,display:'flex'}}>
                        <Autocomplete
                            disablePortal
                            id={"combo-box-male-cat"}
                            options={allParticipants}
                            getOptionLabel={(option) => `#${option.number} - ${option.name} (${option.office})`}
                            sx={{ width: 300}}
                            // fullWidth
                            value = {selectedStarNigth}
                            onChange={(event, newValue) => {
                                setSelectedStarNigth(newValue);
                                }}
                            renderInput={(params) => <TextField {...params} label="Participants" />}
                        />
                    <Button variant='contained' onClick={handleVoteStar} startIcon={<ThumbUpIcon/>}>Vote</Button>
                    </Paper>
                    </Grow>
                }
                </Grid>
            </>
        </Grid>
    )
}